import React from 'react'
import { connect } from 'react-redux'
import Select from 'react-select'
import TransferHistoryActions from '../../Redux/TransferHistoryRedux'

class MatchPaymentForm extends React.Component {
  constructor (props) {
    super (props)
    this.dateFormat = 'DD MMM YYYY, h:mm:ss a'
    this.state = {
      total_transfer: props.detail.amount,
      order_number: '',
      process_status: 'manual-match',
      notes: ''
    }
  }

  _submit = (event) => {
    if (event) event.preventDefault()
    const {
      order_number,
      process_status,
      notes
    } = this.state

    const data = {
      id: this.props.detail.id,
      form: {
        order_number: order_number.value || '',
        process_status,
        notes
      }
    }
    this.props.update(data)
    this.props.closeModal()
  }

  render() {
    const { transfer_history, detail } = this.props

    let order_list = []
    if (detail.orders && detail.orders.length) {
      detail.orders.map((item, i) => {
        order_list.push({
          value: item.order_number,
          label: `[ ${item.order_number} ] - ${item.final_amount}`
        })
        return order_list
      })
    }

    return (
      <form onSubmit={(event) => this._submit(event)} className="section" style={{ width: '30vw' }}>
        <header className="title-block">
          <h4 className="title mr-auto">
            Payment Manual Match <div className="badge badge-dark ml-2">{detail.seq_no || '-'}</div> 
            {(transfer_history.fetching || transfer_history.processing) && 
              <div className="badge badge-info ml-2">{transfer_history.fetching ? 'Loading' : 'Processing'} ...</div> 
            }
          </h4>
        </header>

        <section className="section">
          <div className="form-group">
            <label className="control-label">Total Transfer</label>
            <input type="number" className="form-control" readOnly value={this.state.total_transfer}/>
          </div>

          <div className="form-group" style={{ position: 'relative' }}>
            <label className="control-label">Order List</label>
            <Select options={order_list} value={this.state.order_number} required onChange={(order_number) => this.setState({ order_number })}/>
            <input value={this.state.order_number.value || ''} required style={{ position: 'absolute', zIndex: '-1', top: '50%', left: '30%' }}/>
          </div>
        </section>

        <div className="text-right">
          <button type="button" className="btn btn-lg btn-secondary mr-2" onClick={() => this.props.closeModal()}>Close</button>
          <button type="submit" className="btn btn-lg btn-primary">Save</button>
        </div>
      </form>
    )
  }
}

const stateToProps = (state) => ({
  transfer_history: state.transfer_history
})

const dispatchToProps = (dispatch) => ({
  update: (data) => dispatch(TransferHistoryActions.transferHistoryUpdateRequest(data))
})

export default connect(stateToProps, dispatchToProps)(MatchPaymentForm)



// WEBPACK FOOTER //
// ./src/Containers/Order/MatchPaymentForm.js